// extracted by mini-css-extract-plugin
module.exports = {"lights":"Lights_lights__VNX--","light":"Lights_light__2S2Rk","isActive":"Lights_isActive__-j86P"};